import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import ROUTES from '@/router/routes';
import { TipoProductoTO } from '@/types/myAccount';
import { PAYMENT_METHODS, PaymentMethod } from '@/utils/constants';

type MethodParams = {
  product?: TipoProductoTO;
  moneyToWallet?: number;
  paymentMethod?: PaymentMethod | null;
};

export const useHandlePaymentMethod = () => {
  const navigate = useNavigate();
  const { isMobile } = useIsDesktop();
  const { updatePinsData, pinsData } = usePinsAccount();

  const goToPaymentMethod = useCallback(
    ({ product, moneyToWallet, paymentMethod }: MethodParams) => {
      const isCardSelection = Boolean(
        PAYMENT_METHODS.DEB_CRED === paymentMethod
      );

      const canPayWithBalance = product
        ? pinsData.accountMoney >= product.precio
        : false;

      if (product?.id || Boolean(moneyToWallet)) {
        if (canPayWithBalance) {
          setTimeout(() => {
            updatePinsData({
              selectedProduct: product,
              showModalPayWithBalance: true,
            });
          }, 0);

          return;
        }
        if (isMobile) {
          if (isCardSelection) {
            navigate(ROUTES.selectPaymentCard, { replace: false });
          } else {
            navigate(ROUTES.paymentMethodSelection, { replace: false });
          }
        }
        updatePinsData({
          selectedProduct: product,
          moneyToWallet,
          showPaymentModalMethod: Boolean(
            product ||
              (moneyToWallet && !product) ||
              pinsData.showPaymentModalMethod
          ),
          showWalletLoadModal: Boolean(
            moneyToWallet ||
              (pinsData.moneyToWallet && !product) ||
              pinsData.showWalletLoadModal
          ),
          ...(paymentMethod && { selectedPaymentMethod: paymentMethod }),
        });
      }
    },
    [
      isMobile,
      navigate,
      pinsData.accountMoney,
      pinsData.moneyToWallet,
      pinsData.showPaymentModalMethod,
      pinsData.showWalletLoadModal,
      updatePinsData,
    ]
  );

  return { handlePaymentMethod: goToPaymentMethod };
};
